class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-pc',
        section: 'cart-icon-bubble-pc',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        section: 'cart-modal',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-hover-modal',
        section: 'cart-hover-modal',
        selector: '#cart-hover-modal',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionHTML = parsedState.sections[section.section];
          if (typeof sectionHTML === 'undefined') return;

          const sectionElement = document.getElementById(section.id);
          if (!sectionElement) return;

          const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.syncCartCount(parsedState.item_count);
        this.refreshCartDrawerControls(cartDrawerWrapper);

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings?.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return '';

    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  refreshCartDrawerControls(cartDrawerWrapper) {
    if (!cartDrawerWrapper) return;

    const overlay = cartDrawerWrapper.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', cartDrawerWrapper.close.bind(cartDrawerWrapper));

    const continueButton = cartDrawerWrapper.querySelector('.cart-continue-btn');
    if (continueButton) continueButton.addEventListener('click', cartDrawerWrapper.close.bind(cartDrawerWrapper));
  }

  syncCartCount(itemCount) {
    const count = Number(itemCount) || 0;

    document.querySelectorAll('.cart-page-title span').forEach((element) => {
      element.textContent = `(${count})`;
    });

    document.querySelectorAll('.header-pc-cart-badge, .b2b-header__cart-badge').forEach((badge) => {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
    });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class CartProductForm extends HTMLElement {
  constructor() {
    super();

    console.log('Cart Product Form!!!');
  }
}

customElements.define('cart-product-form', CartProductForm);

class CartWholesaleAgreement extends HTMLElement {
  constructor() {
    super();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form = this.closest('form') || document.querySelector('#cart');
    this.checkoutButton = document.querySelector('[data-wholesale-agreement]');
    this.checkbox = this.querySelector('input[type="checkbox"]');

    if (this.checkbox) {
      // 移除可能存在的旧事件监听器
      this.checkbox.removeEventListener('change', this._boundHandleChange);
      this._boundHandleChange = this.handleChange.bind(this);
      this.checkbox.addEventListener('change', this._boundHandleChange);
    }
    // 已全局委托拦截，无需再绑定form.submit和checkout click
  }

  handleChange(event) {
    const checkoutButton = document.querySelector('#checkout');
    if (checkoutButton) {
      checkoutButton.disabled = !event.target.checked;
    }
    // 勾选协议时移除error类
    if (event.target.checked) {
      const container = this.querySelector('.cart__agreement-container');
      if (container && container.classList.contains('error')) {
        container.classList.remove('error');
      }
    }
  }

  showError() {
    const container = this.querySelector('.cart__agreement-container');
    container.classList.add('error'); // 只负责高亮
    // 注入shake动画样式（如未注入）
    if (!document.getElementById('cart-agreement-shake-style')) {
      const style = document.createElement('style');
      style.id = 'cart-agreement-shake-style';
      style.textContent = `
        @keyframes cart-agreement-shake {
          0% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
          100% { transform: translateX(0); }
        }
        .cart__agreement-container.shake {
          animation: cart-agreement-shake 0.3s cubic-bezier(.36,.07,.19,.97) both;
        }
        .cart__agreement-container.error {
          border-color: #eb001b !important;
        }
      `;
      document.head.appendChild(style);
    }
    // 触发shake动画
    container.classList.remove('shake');
    void container.offsetWidth;
    container.classList.add('shake');
    container.addEventListener('animationend', function handler() {
      container.classList.remove('shake');
      container.removeEventListener('animationend', handler);
    });
  }

  disconnectedCallback() {
    console.log('Component disconnected - cleaning up listeners');
    // 只需解绑checkbox change
    if (this.checkbox && this._boundHandleChange) {
      this.checkbox.removeEventListener('change', this._boundHandleChange);
    }
  }
}

customElements.define('cart-wholesale-agreement', CartWholesaleAgreement);

// 事件委托：全局拦截购物车协议
(function () {
  document.addEventListener(
    'click',
    function (e) {
      // 只拦截主购物车结算按钮
      if (e.target && e.target.id === 'checkout') {
        const wholesaleAgreement = document.querySelector('cart-wholesale-agreement');
        if (wholesaleAgreement) {
          const checkbox = wholesaleAgreement.querySelector('input[type="checkbox"]');
          if (!checkbox?.checked) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (typeof wholesaleAgreement.showError === 'function') {
              wholesaleAgreement.showError();
            }
            wholesaleAgreement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    },
    true
  );
})();
